// for SEO (GR-14325)
export const seoMetaTitleExceptions = [
  'Data Science',
  'Machine Learning',
  'Entrepreneurship',
  'Algorithms',
  'Business',
];
